import { triggerIngestion } from './ingestionApi';
import { apiRequest } from './httpClient';

// Access-list refresh should reuse saved files by default. Upstream fetching is centralized through ingestionApi.

export async function fetchAccessListDiff(signal) {
    return apiRequest('/access-list/diff', { signal });
}

export async function refreshAccessListDiff(signal, trigger = 'frontend-access-list') {
    await triggerIngestion(trigger);
    return apiRequest('/access-list/refresh?fetch=false', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal
    });
}

export async function fetchAccessListHistory(queryParams) {
    const [history, stats] = await Promise.all([
        apiRequest(`/access-list/changes?${queryParams}`),
        apiRequest(`/access-list/changes/stats?${queryParams}`)
    ]);
    return { history, stats };
}

export async function backfillAccessListHistory(includeArchives = true) {
    return apiRequest('/access-list/changes/backfill', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ includeArchives })
    });
}
